import React from "react";

import { brl } from "../lib/formato";

// Rodapé da comanda da mesa: total, o que já foi pago e o que falta. Sem
// nenhum pagamento fica só o "Total da mesa", como era antes.
export default function ResumoContaMesa({ total, pago, className = "" }) {
  const temPago = pago > 0.004;
  return (
    <div className={`space-y-1 text-sm ${className}`} data-e2e="comanda-resumo">
      <div className="flex justify-between items-center text-muted-foreground">
        <span>Total da mesa</span>
        <span className="font-semibold text-foreground">{brl(total)}</span>
      </div>
      {temPago ? (
        <>
          <div className="flex justify-between items-center text-emerald-600 dark:text-emerald-400">
            <span>Pago</span>
            <span className="font-semibold" data-e2e="comanda-resumo-pago">− {brl(pago)}</span>
          </div>
          <div className="flex justify-between items-center font-bold">
            <span>Falta pagar</span>
            <span data-e2e="comanda-resumo-falta">{brl(Math.max(0, total - pago))}</span>
          </div>
        </>
      ) : null}
    </div>
  );
}
